import(/* webpackMode: "eager", webpackExports: ["default"] */ "/code/src/_layout/pageWrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/code/src/app/sporten-in-groningen/(withSidebarLayout)/_layout.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/code/src/core/sections/breadcrumbs/index.js");
